import { connect } from 'react-redux';
import { closeSideBar, getParams } from '../../../store/sidebar';
import { requestObject } from '../../../store/Object';
import { requestObjects } from '../../../store/Objects';
import { Instances } from '../../../constants';
import EditExpiryModal from '../organisms/editExpiryModal';
import {
    DispatchPropsType,
    MapStateType,
} from '../organisms/editExpiryModal';

const mapStateToProps = (state: any) => ({
    params: getParams(state),
});

const mapDispatchToProps = {
    onClose: () => closeSideBar(),
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.bulkEditExpiryDate, undefined, undefined, 'put', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onLoad: () => requestObjects(Instances.urlShortenerList, undefined, { page: true }),
    onBulkLoad: (bulkid: string) => requestObjects(Instances.bulkUrlShortenerDetailList, { bulk_id: bulkid }, { page: true, searchTerm: "title" }),
}

export default connect<MapStateType, DispatchPropsType, unknown, any>(
    mapStateToProps,   
    mapDispatchToProps
)(EditExpiryModal);